"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientError = ClientError;

var _react = _interopRequireDefault(require("react"));

var _UI = require("../UI");

function ClientError() {
  return _react["default"].createElement(_UI.SpecialPageContent, null, _react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, "Something went wrong. ", _react["default"].createElement("div", {
    style: {
      width: '0.5em',
      height: '0.5em'
    }
  }), _react["default"].createElement("button", {
    onClick: function onClick() {
      window.location.reload();
    }
  }, "reload page")));
}